export const SAN_FRANCISCO_COORDINATES = {
  lat: 37.81550523889406,
  lng: -122.38713192156683,
};
